// these are the address fields saved directly to the user resource
export const types = {
  street_number: true,
  route: true,
  locality: true,
  administrative_area_level_1: true,
  postal_code: true,
}
